import React, { useEffect, useRef } from 'react';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Tab from '@mui/material/Tab';
import Typography from '@mui/material/Typography';

import Discussion from './Discussion';
import { useParams } from 'react-router-dom';
import ProfileDetailModal from './ProfileDetailModal';
import {
  useLecturersByModuleQuery,
  useRoutineCourseSessionListQuery
} from 'redux/reducers/user/dashboard/tms-dashboardTrainee';

const CourseSession = ({ activeModule }: { activeModule: string }) => {
  const { training_id: routineId } = useParams();
  const [tabValue, setTabValue] = React.useState('1');
  const moduleInfoRef = useRef<HTMLDivElement | null>(null);
  const { data: lecturersByModule = [], isLoading: LecturersLoading } = useLecturersByModuleQuery(
    routineId ?? '',
    activeModule
  );

  const { data: routineCourseSessionList = [], isLoading } = useRoutineCourseSessionListQuery(
    routineId ?? '',
    activeModule
  );

  const [modalOpen, setModalOpen] = React.useState(false);

  const handleTabChange = (event: React.SyntheticEvent, newValue: string) => {
    setTabValue(newValue);
  };

  const tabList =
    lecturersByModule?.data?.map((r: any) => ({
      title: r.title,
      course_topic_id: r.course_topic_id,
      course_title: r.course_details.title,
      details: r.course_topic_files_list
    })) ?? [];

  const [sessionId, setSessionId] = React.useState('');
  const [lecturerId, setLecturerId] = React.useState('');

  const lecturers =
    lecturersByModule?.data?.filter((item: any) => item?.course_topic_id === sessionId)?.pop()
      ?.lecturer || [];

  const getObjective = (learning_objective: string) => {
    try {
      return JSON.parse(learning_objective)
        .blocks.map((b: { text: string }) => b.text)
        .join(' ');
    } catch (error) {
      return '';
    }
  };

  useEffect(() => {
    setTabValue('1');
    moduleInfoRef.current?.scrollIntoView({
      behavior: 'smooth',
      block: 'end',
      inline: 'nearest'
    });
  }, [activeModule]);

  useEffect(() => {
    setSessionId(tabList[0]?.course_topic_id);
  }, [tabList[0]?.course_topic_id]);

  return (
    <>
      <Box
        sx={{ width: '100%', typography: 'body1', backgroundColor: 'white' }}
        ref={moduleInfoRef}>
        <TabContext value={tabValue}>
          <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
            <TabList
              variant="scrollable"
              onChange={handleTabChange}
              aria-label="">
              {tabList.map((item: any, index: number) => (
                <Tab
                  key={index}
                  label={
                    <Typography fontSize={14} fontWeight={400}>
                      {item.title}
                    </Typography>
                  }
                  value={(index + 1).toString()}
                  onClick={(_) => setSessionId(item?.course_topic_id)}
                />
              ))}
            </TabList>
          </Box>
          <Box>
            <Grid container paddingLeft={4} paddingTop={1}>
              <Typography fontSize={20} fontWeight={600} color={'primary'}>
                {' '}
                Lecturers
              </Typography>
              <Grid container sx={{ marginTop: '10px' }}>
                {lecturers?.map((lecturer: any) => (
                  <Grid
                    item
                    xs={4}
                    key={lecturer?.id}
                    style={{
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      height: '30px'
                    }}
                    onClick={() => {
                      setLecturerId(lecturer?.id);
                      setModalOpen(true);
                    }}>
                    <Typography
                      fontSize={16}
                      fontWeight={400}
                      color={'primary'}
                      style={{ cursor: 'pointer' }}>
                      {lecturer.first_name + ' ' + lecturer.last_name}
                    </Typography>
                  </Grid>
                ))}
              </Grid>
            </Grid>
            <ProfileDetailModal
              modalOpen={modalOpen}
              setModalOpen={setModalOpen}
              lecturerId={lecturerId}
            />
          </Box>

          {tabList?.map((tab: any, i: number) => (
            <TabPanel value={(i + 1).toString()} key={i + 1}>
              <Box>
                <Grid container>
                  <Grid padding={1} xs={12}>
                    {/* <Typography variant="body2">
                      {getObjective(
                        courseSession?.results?.find(
                          (item) => item.course_topic_id === tab.course_topic_id
                        )?.description ?? ""
                      )}
                    </Typography> */}

                    <Discussion
                      activeModule={activeModule}
                      sessionId={tab.course_topic_id}
                      detail={tab?.details}
                      courseTitle={'coursetopic'}
                    />
                  </Grid>
                </Grid>
              </Box>
            </TabPanel>
          ))}
        </TabContext>
      </Box>
    </>
  );
};

export default CourseSession;
